@if (calendarInfoDisplay && !gridEventDisplayOverride) {
    <div class="calendar-grid-info">
        <div class="calendar-timer-badge">
            <ms-event-timer
                class="grid-event-timer"
                [calendarInfoDisplay]="calendarInfoDisplay"
                [live]="event.live"
                [start]="event.startDate"
                [scoreboard]="event.scoreboard">
            </ms-event-timer>
        </div>
        <div class="calendar-event-info">
            <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
        </div>
    </div>
} @else {
    <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
}
<ng-template #defaultTemplate>
    @if (isTwoThreeWayEnabled || gridEventDisplayOverride) {
        <div class="grid-event-header-wrapper">
            <div class="event-timer-scoreboard-info">
                <div class="event-timer-scoreboard-info-header">
                    <ms-event-info
                        [mediaEnabled]="media.enabled"
                        [disableBadges]="true"
                        [showEventTimerInfoSection]="true"
                        [showFixedFooterSection]="false"
                        [event]="event"
                        (click)="eventInfoClick()">
                    </ms-event-info>
                    @if (isTwoThreeWayEnabled) {
                        <ms-grid-scoreboard-header [event]="event"></ms-grid-scoreboard-header>
                    }
                </div>
            </div>
            @for (group of groups; track group.id) {
                <ms-group-header [group]="group" [overriddenHeaderName]="overriddenMarketHeader(group)"></ms-group-header>
            }
        </div>
    }
    @if (hasFallbackMarket) {
        <div class="fallback-market-header">
            {{ fallbackMarketName }}
        </div>
    }
    <div
        class="grid-event-wrapper"
        [class.image]="showParticipantImage && !isAllMarketsLinkEnabled"
        [class.has-participant-statistics]="!isTwoThreeWayEnabled && showParticipantStats"
        [class.empty]="empty"
        (click)="eventClick($event)">
        <a
            class="grid-info-wrapper"
            dsTouchClick
            [class.fixed]="media.enabled"
            [href]="eventUrl"
            [vnSpeculativeLink]="eventUrl"
            [msRemoveHref]="shouldRemoveHref"
            [class.has-all-markets]="isAllMarketsLinkEnabled"
            [class.image]="showParticipantImage">
            <ms-event-detail
                [event]="event"
                [mediaEnabled]="media.enabled"
                [promotedFixtureIdsMap]="promotedFixtureIdsMap"
                [showParticipantImage]="showParticipantImage"
                [showEventTimerInfoSection]="!isTwoThreeWayEnabled && !gridEventDisplayOverride"
                [showParticipantStats]="showParticipantStats"
                [gameNotes]="gameNotes"
                [isAllMarketsLinkEnabled]="isAllMarketsLinkEnabled"
                [showLogoColor]="showLogoColor"></ms-event-detail>
            <ms-grid-scoreboard [event]="event" [hideScoreBoardColumnFooter]="isTwoThreeWayEnabled" [tracking]="trackingSource"></ms-grid-scoreboard>
            @if (event.fixtureForm) {
                <ms-fixture-form [event]="event"></ms-fixture-form>
            }
        </a>
        @if (media.enabled) {
            <ms-event-media
                [event]="event"
                [media]="media"
                [tracking]="trackingSource"
                [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
                (statsClicked)="statsClicked.emit()"></ms-event-media>
        }
        <div class="grid-group-container" [class.btn-cta-ogp]="betBuilderEpcotEnabled">
            @if (optionGroupTemplate) {
                <a class="grid-option-group empty" [href]="eventUrl" [vnSpeculativeLink]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                    <ng-container
                        *ngTemplateOutlet="
                            optionGroupTemplate;
                            context: { event: event, hasPreCreated: true, betBuilderEpcotEnabled: betBuilderEpcotEnabled }
                        "></ng-container>
                </a>
            } @else {
                @if (empty) {
                    <a class="grid-option-group empty" [href]="eventUrl" [vnSpeculativeLink]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                        <ms-font-resizer defaultSize="1" maxChars="emptyChars" [value]="emptyText"></ms-font-resizer>
                        <vn-icon class="icon-alignment" name="theme-right" [size]="iconSize"></vn-icon>
                    </a>
                } @else {
                    <ms-option-group
                        *rxFor="let group of groups; trackBy: trackOptionGroup; let i = index"
                        [optionGroup]="groupsMap[group.id]"
                        [event]="event"
                        [group]="group"
                        [tracking]="trackingSource"
                        [showOptionname]="showOptionname"
                        [betDetails]="betDetailsSource"
                        [verticalDesignOptions]="getVerticalDesignOptions(group)"
                        [showCenterOptionName]="showCenterOptionName">
                    </ms-option-group>
                }
            }
        </div>
        @if (favouriteToggle) {
            <ms-favourite-event-toggle [event]="event" [static]="true" [tracking]="trackingSource"></ms-favourite-event-toggle>
        }

        @if (hasBetsCountButton) {
            <a
                class="bets-count-button"
                [href]="eventUrl"
                [vnSpeculativeLink]="eventUrl"
                [msRemoveHref]="shouldRemoveHref"
                (click)="trackMoreBets($event)">
                <span class="bets-count-span">{{ betsCountMessage }}</span>
                <vn-icon class="icon-alignment" name="theme-right" size="13"></vn-icon>
            </a>
        }
    </div>
    @if (gameNotes && isAllMarketsLinkEnabled) {
        <ms-game-notes [gameNotes]="gameNotes"></ms-game-notes>
    }
    @if (isAllMarketsLinkEnabled) {
        <ms-event-footer
            class="badges-wrapper all-markets"
            [event]="event"
            [mediaEnabled]="media.enabled"
            [promotedFixtureIdsMap]="promotedFixtureIdsMap"
            [eventUrl]="eventUrl"
            [showEventTimerInfoSection]="!isTwoThreeWayEnabled && !gridEventDisplayOverride"
            [showFixedFooterSection]="true"></ms-event-footer>
    }
</ng-template>
